import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-bottom"><path d="M19.25 4.75H4.75L12 19.25L19.25 4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowTriangleBottom;
